import { css as i } from "@microsoft/fast-element";
import { designTokens as o } from "../design-tokens.js";
import { selectorState as r } from "./utils.js";
import { typography as n } from "./typography.js";
const e = (t) => i`
  ${t} {
    /* Style */
    background-color: ${o.color.primary[40]};
    color: ${o.color.primary[500]};
  }

  ${t} > .content {
    /* Typography */
    font-weight: ${o.fontWeight.semibold};
  }
`, p = (t) => i`
  ${e(r(t, ":active"))}
  ${t} {
    /* Base */
    user-select: none;
    cursor: pointer;
    min-height: ${o.spacing[8]};
    /* Layout */
    padding: ${o.spacing[1]} ${o.spacing[4]};
    align-items: center;
    gap: ${o.spacing[2]};
    /* Style */
    background-color: ${o.color.white};
    color: ${o.color.neutral[100]};
    /* Transitions */
    transition: background-color ${o.transition.fast},
      color ${o.transition.fast};
  }

  ${r(t, ":hover")},
  ${r(t, ":focus-visible")} {
    /* Style */
    background-color: ${o.color.primary[40]};
    color: ${o.color.primary[100]};
  }

  ${r(t, ":focus-visible")} {
    /* Style */
    outline-color: ${o.color.black};
    outline-offset: ${o.borderWidth.sm};
  }

  .content {
    /* Layout */
    flex-grow: 1;
    /* Typography */
    ${n("p", "regular")}
  }

  .content::after {
    /* Base */
    display: block;
    content: attr(data-text);
    font-weight: 600;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;
export {
  e as activeMenuItemStyles,
  p as menuItemStyles
};
